import { memo } from 'react';
import { cn } from '@/app/lib';
import { IconChatbot } from '@workspace/assets/images';

interface ChatButtonProps {
  isOpen: boolean;
  onClick: () => void;
  iconUrl?: string;
}

function ChatButton({ isOpen, onClick }: ChatButtonProps) {
  return (
    <div className="sticky bottom-18 left-full z-[1000] inline-block -translate-x-5 translate-y-2/3 pb-12">
      <button
        onClick={onClick}
        className="relative p-4 border-none bg-primary cursor-pointer rounded-full shadow-lg group"
        aria-label={isOpen ? 'Close chat' : 'Open chat'}
      >
        <img src={IconChatbot} alt="Chat" className="size-14 transition duration-200 hover:scale-105" />
        {!isOpen && (
          <span
            className={cn(`
              absolute top-0 left-12
              -translate-x-full origin-bottom-right
              inline-block w-48
              bg-white rounded-full p-2
              border-1 border-secondary-100
              shadow-lg/2
              pointer-events-none
              after:absolute after:right-4 after:bottom-2
              after:w-0 after:h-0
              after:translate-y-full
              after:border-14 after:border-transparent
              after:border-t-18 after:border-t-white
              opacity-0 translate-y-2 transition duration-200
              group-hover:opacity-100 group-hover:-translate-y-2/3
            `)}
          >
            Hi, how can I help?
          </span>
        )}
      </button>
    </div>
  );
}

export default memo(ChatButton);
